import { FC, ReactNode } from 'react';
import { Box, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LimitMessageWithUpgradeProps {
    message: ReactNode;
}

export const UPGRADE_PAGE_PATH = '/company';

export const LimitMessageWithUpgrade: FC<LimitMessageWithUpgradeProps> = ({ message }) => {
    const { t } = useTranslation();
    return (
        <Box component="span">
            {message}{' '}
            <Link
                component={RouterLink}
                to={UPGRADE_PAGE_PATH}
                color="inherit"
                sx={{
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    whiteSpace: 'nowrap'
                }}
            >
                {t('upgrade_now')}
            </Link>
        </Box>
    );
};
